import { ProtectedJsonAPI } from '.'

export const ContactUs = ProtectedJsonAPI.extend(
  '/contact_us',
  {
    create: endpoint => endpoint.method('post')
  }
)